import React from 'react';
import './SkipToContent.css';

const SkipToContent = () => {
  const skipToMain = () => {
    const mainContent = document.getElementById('hero');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href="#hero"
      className="skip-to-content"
      onClick={(e) => {
        e.preventDefault();
        skipToMain();
      }}
    >
      Skip to main content
    </a>
  );
};

export default SkipToContent;
